import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/banners/mobile-application-avatar.webp")